import React, { useEffect, useState } from "react";
import useDebounce from "../../../customHooks/useDebounce";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import { SearchIcon } from "../../../components/Icon";
import { EmptyList } from "../../../assets/images";
import { RootState } from "../../../redux/rootReducers";
import {
  getAllFinacUsersAction,
  resetFinacUsersList,
  resetSession,
} from "../../../redux/auth";
import { connect } from "react-redux";
import {
  getAllExternalUserEmailerAction,
  resetAllExternalUserEmailerList,
  resetAllExternalUserEmailerTotalCount,
  resetListingError,
  resetListingSuccess,
} from "../../../redux/listing";
import {  GetAllExternalEmailerListType } from "../../../commonTypes/listing";
import ClientSorting from "../../../components/AdminReports/AllClientLockDate/ClientSorting";
import AllExternalUserEmailerTable from "../../../components/AdminReports/AllExternalUserEmailer/AllExternalUserEmailerTable";
import ShowAllEmailersModal from "../../../components/AdminReports/AllExternalUserEmailer/ShowAllEmailersModal";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import AllExternalEmailerFilter from "../../../components/AdminReports/AllExternalUserEmailer/AllExternalEmailerFilter";

export type DropDownItemType = {
  value: number | null | undefined;
  label: string;
};
export type FilterMultiSelectDataType = {
  user: { label: string; value: number | null };
};
type AppProps = {
  fetching: boolean;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  token: null | string;
  allExternalUserEmailerTotalCount: number;
  allExternalUserEmailerList: any[] | [];
  dispatchResetSession: () => void;
  dispatchResetListingError: () => void;
  dispatchResetListingSuccess: () => void;
  dispatchResetAllExternalUserEmailerList: () => void;
  dispatchGetAllExternalUserEmailerAction: (
    data: GetAllExternalEmailerListType
  ) => void;
  dispatchResetAllExternalUserEmailerTotalCount: () => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchResetFinacUsersList: () => void;
  userFetching: boolean;
  totalUserCount: number | string | any;
  finacUsersList: any;
};

const AllExternalUserEmailers = ({
  fetching,
  success,
  error,
  token,
  statusCode,
  allExternalUserEmailerList,
  allExternalUserEmailerTotalCount,
  dispatchResetSession,
  dispatchResetListingError,
  dispatchResetListingSuccess,
  dispatchResetAllExternalUserEmailerList,
  dispatchGetAllExternalUserEmailerAction,
  dispatchResetAllExternalUserEmailerTotalCount,
  dispatchGetAllFinacUsersAction,
  dispatchResetFinacUsersList,
  userFetching,
  totalUserCount,
  finacUsersList,
}: AppProps) => {
  const [limit, setLimit] = useState(20);
  const [offset, setOffset] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [finalListingData, setFinalListingData] = useState<any>([]);
  const [sortBy, setSortBy] = useState({
    id: "Client Code - Ascending",
    value: "asc",
    _id: "client_code#asc",
    name: "Client Code - Ascending",
  });
  const [isApiCall, setIsApiCall] = useState<boolean>(false);
  const [showAllEmailersModal, setShowAllEmailersModal] =
    useState<boolean>(false);
  const [singleEmailerInfo, setSingleEmailerInfo] = useState([]);
  const [finalUserList, setFinalUserList] = useState<DropDownItemType[] | []>(
    []
  );
  const [filterToggle, setFilterToggle] = useState<boolean>(false);

  const [filterText, setFilterText] = useState("");
  const [filterOffset, setFilterOffset] = useState(0);
  const [filterLimit, setFilterLimit] = useState(20);
  const [filterValue, setFilterValue] = useState<FilterMultiSelectDataType>({
    user: { label: "", value: null },
  });
   const [multiSelectData, setMultiSelectData] =
      useState<FilterMultiSelectDataType>({
      
        user: { label: "", value: null },
      });

  useEffect(() => {
    dispatchResetAllExternalUserEmailerList();
    dispatchResetListingError();
    dispatchResetListingSuccess();
    dispatchResetAllExternalUserEmailerTotalCount();
    dispatchResetFinacUsersList();
    window.scroll({
      top: 0,
      left: 0,
    });
  }, []);

  useEffect(() => {
    dispatchResetListingError();
    dispatchResetListingSuccess();

    if (token && isApiCall) {
      let sortingBy = sortBy?._id?.split("#");
      const finalData = {
        token,
        offset,
        limit,
        search_term: searchValue,
        userId: filterValue?.user?.value ? filterValue?.user?.value : null,
      };
      if (allExternalUserEmailerTotalCount) {
        if (offset < allExternalUserEmailerTotalCount) {
          dispatchGetAllExternalUserEmailerAction(finalData);
          setIsApiCall(true);
        }
      } else {
        dispatchGetAllExternalUserEmailerAction(finalData);
        setIsApiCall(true);
      }
    }
  }, [offset]);

  useEffect(() => {
    if (allExternalUserEmailerList?.length === 0) {
      setFinalListingData(allExternalUserEmailerList);
    }
    if (offset > 0) {
      setFinalListingData((prv: any) => [
        ...prv,
        ...allExternalUserEmailerList,
      ]);
    } else {
      setFinalListingData(allExternalUserEmailerList);
    }
  }, [allExternalUserEmailerList]);

  //
  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        search_term: filterText,
        user_type: "external_user",
        limit,
        offset: filterOffset,
        status: "1",
      };

      if (+finacUsersList?.total_count) {
        if (+finacUsersList?.total_count > filterOffset) {
          dispatchGetAllFinacUsersAction(finalData);
        }
      } else {
        dispatchGetAllFinacUsersAction(finalData);
      }
    }
  }, [filterOffset]);

  const fetchNewFilterData = (search: string) => {
    const finalData = {
      token,
      offset: filterOffset,
      limit,
      user_type: "external_user",
      status: 1,
      search_term: filterText,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };
  useDebounce(
    () => {
      if (filterText) {
        fetchNewFilterData(filterText);
      } else {
        const finalData = {
          token,
          offset: filterOffset,
          limit,
          user_type: "external_user",
          status: 1,
          search_term: "",
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [filterText]
  );

  useEffect(() => {
    if (finacUsersList?.data?.length > 0) {
      if (filterOffset <= +finacUsersList?.total_count) {
        let finalUserData = finacUsersList?.data?.map((user: any) => {
          return {
            value: user?.user_id,
            label: `${user?.first_name} ${user?.last_name}`,
            image: user?.profile_pic?.file_url,
          };
        });
        if (filterOffset > 0) {
          setFinalUserList([...finalUserList, ...finalUserData]);
        } else {
          setFinalUserList([...finalUserData]);
        }
      }
    }
  }, [finacUsersList?.data]);
  //

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < allExternalUserEmailerTotalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (allExternalUserEmailerList?.length > 0) {
          if (!fetching && offset < allExternalUserEmailerTotalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [allExternalUserEmailerList]);

  useDebounce(
    () => {
      if (searchValue) {
        fetchNewData();
      }
    },
    500,
    [searchValue]
  );

  const fetchNewData = () => {
    let sortingBy = sortBy?._id?.split("#");
    const finalData = {
      token,
      offset,
      limit,
      search_term: searchValue,
      userId: filterValue?.user?.value ? filterValue?.user?.value : null,

    };
    if (token) {
      if (offset === 0) {
        dispatchGetAllExternalUserEmailerAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  useEffect(() => {
    let sortingBy = sortBy?._id?.split("#");
    let finalData = {
      token,
      offset: 0,
      limit,
      search_term: searchValue,
      userId: filterValue?.user?.value ? filterValue?.user?.value : null,
    };
    setIsApiCall(true);
    dispatchGetAllExternalUserEmailerAction(finalData);
  }, [sortBy]);

  const handleSort = (data: any) => {
    setOffset(0);
    setSortBy(data);
  };

  const toggleViewAllEmailersModal = () => {

    setShowAllEmailersModal(!showAllEmailersModal);
  };

  const handleShowAllEmailerAssigned = (data: any) => {
    setShowAllEmailersModal(true);
    setSingleEmailerInfo(data);
  };

  const handleSearch = (e: any) => {
    let sortingBy = sortBy?._id?.split("#");
    let value = e.target.value;
    setSearchValue(value);
    if (value?.length === 0) {
      const finalData = {
        token,
        offset,
        limit,
        userId: filterValue?.user?.value ? filterValue?.user?.value : null,
      };
      if (token) {
        if (offset === 0) {
          dispatchGetAllExternalUserEmailerAction(finalData);
        } else {
          setOffset(0);
        }
      }
    }
  };

  const handleApplyFilter = () => {
    dispatchResetAllExternalUserEmailerList();
    setFinalListingData([]);
    setOffset(0);
    setMultiSelectData({
       
        user: filterValue?.user,
      });

    if (token) {
      let sortingBy = sortBy?._id?.split("#");
      let finalData = {
        token,
        offset: 0,
        limit,
        search_term: searchValue,
        userId: filterValue?.user?.value ? filterValue?.user?.value : null,
      };
      dispatchGetAllExternalUserEmailerAction(finalData);
    }
  };

  const handleFilterClear = () => {
    dispatchResetAllExternalUserEmailerList();
    setFilterValue({
      user: { label: "", value: null },
    });
    setMultiSelectData({
        user: { label: "", value: null },
      });

    if (token) {
      let sortingBy = sortBy?._id?.split("#");
      let finalData = {
        token,
        offset: 0,
        limit,
        search_term: searchValue,
     
      };
      dispatchGetAllExternalUserEmailerAction(finalData);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetListingError();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <div className="row">
      <div className="col-md-6 mb-3">
        <CommonHeader title="Emailer Template" />
      </div>
      <div className="col-md-12">
        <div className="jobs-card">
          <div className="header">
            <div className="left-header">
              <div className="heading">Emailer Template List</div>
              {!fetching && (
                <div
                  className="sub-heading"
                  style={{ marginTop: "-22px" }}
                >{`Total ${
                  allExternalUserEmailerTotalCount
                    ? allExternalUserEmailerTotalCount
                    : 0
                }  list found`}</div>
              )}
            </div>
            <div className="right-header">
              <div className="col-md-9 position-relative">
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e: any) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchValue}
                />
              </div>
             
              <div className="mr-1">
                <AllExternalEmailerFilter
                  setToggle={setFilterToggle}
                  toggle={filterToggle}
                  filterValue={filterValue}
                  setFilterValue={setFilterValue}
                  limit={limit}
                  handleApplyFilter={handleApplyFilter}
                  handleFilterClear={handleFilterClear}
                  finalUserList={finalUserList}
                  setFilterText={setFilterText}
                  filterOffset={filterOffset}
                  setFilterOffset={setFilterOffset}
                  filterText={filterText}
                  multiSelectData={multiSelectData}
                />
              </div>
            </div>
          </div>
          <div>
            {fetching && offset === 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : allExternalUserEmailerList?.length > 0 ? (
              <AllExternalUserEmailerTable
                data={finalListingData}
                fetching={fetching}
                offset={offset}
                handleShowAllEmailerAssigned={handleShowAllEmailerAssigned}
              />
            ) : (
              <div className="mt-5 pb-5">
                {!fetching && allExternalUserEmailerList?.length === 0 && (
                  <EmptyListPage
                    title="No List Found!"
                    image={EmptyList}
                    imageWidth="30%"
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {showAllEmailersModal && (
        <ShowAllEmailersModal
          showAllEmailersModal={showAllEmailersModal}
          toggleViewAllEmailersModal={toggleViewAllEmailersModal}
          singleEmailerInfo={singleEmailerInfo}
        />
      )}

      {handleErrorModal()}
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.listing.success,
  fetching: state.listing.fetching,
  statusCode: state.listing.statusCode,
  error: state.listing.error,
  allExternalUserEmailerList: state.listing.allExternalUserEmailerList,
  allExternalUserEmailerTotalCount:
    state.listing.allExternalUserEmailerTotalCount,
  userFetching: state.auth.fetching,
  finacUsersList: state.auth.finacUsersList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetListingError: () => dispatch(resetListingError()),
  dispatchResetListingSuccess: () => dispatch(resetListingSuccess()),
  dispatchResetAllExternalUserEmailerList: () =>
    dispatch(resetAllExternalUserEmailerList()),
  dispatchGetAllExternalUserEmailerAction: (
    data: GetAllExternalEmailerListType
  ) => dispatch(getAllExternalUserEmailerAction(data)),
  dispatchResetAllExternalUserEmailerTotalCount: () =>
    dispatch(resetAllExternalUserEmailerTotalCount()),

  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchResetFinacUsersList: () => dispatch(resetFinacUsersList()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllExternalUserEmailers);
